import React, { useEffect, useRef, useState } from "react";
import { CrossIcon, DeleteIcon } from "@/constants/utils/svgs";
import Alert from "@/components/alert/Alert";
import { API_ROUTES } from "@/services/environment";
import { DELETE, GET, POST } from "@/services/api";
import { useAppSelector } from "@/hooks/hook";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useDispatch } from "react-redux";
import { formStateChange } from "@/redux/slices/formSlice";
import ChangesAlert from "@/components/alert/ChangesAlert";
import moment from "moment";
import addIcon from "../../assets/icons/addIcon.svg";
import deleteIcon from '../../assets/icons/deleteIcon.svg';
import FormModal from "@/components/modals/FormModal";
import { format } from "date-fns";
import { toZonedTime } from "date-fns-tz";
import { Button, dateFunctionUS } from "@thdinc/hpf-shared";

interface BartenderDateInterFace {
  id?: string;
  date: string;
  start_time: string;
  end_time: string;
  user_id?: string;
}
interface BartenderBlock {
  id: string;
  date: string;
  start_time: string;
  end_time: string;
  is_all_day: boolean;
}
interface ChildProps {
  bartenderBlocks: BartenderBlock[];
  id: string;
  change: boolean;
  setChange: (value: boolean) => void;
}
const BlockDates: React.FC<ChildProps> = ({
  bartenderBlocks,
  id,
  change,
  setChange,
}) => {
  const dispatch = useDispatch();
  const {
    bartenderBlockedDate,
    bartenderOneDaySchedule,
    deleteBartenderOneDaySchedule,
  } = API_ROUTES;
  const { refreshToken } = useAppSelector((store) => store.user);
  type DateValue = Date;
  const [selectedDate, setSelectedDate] = useState<DateValue>(new Date());
  const [allDay] = useState<boolean>(true);
  const [startTime, setStartTime] = useState<string>("09:00");
  const [endTime, setEndTime] = useState<string>("18:00");
  const [error] = useState<boolean>(false);
  const [changed, setChanged] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [blockState, setBlockState] =
    useState<BartenderBlock[]>(bartenderBlocks);
  const [excludedDates, setExcludedDates] = useState<Date[]>([]);
  const [modal, setModal] = useState<boolean>(false);
  const [dateModal, setDateModal] = useState<boolean>(false);
  const [showForm, setShowForm] = useState(false);
  const [activeBlock, setActiveBlock] = useState<BartenderBlock | null>(null);
  const [activeIndex, setActiveIndex] = useState<number>(0);

  // const [readyData, setReadyData] = useState<object | null>(null);
  const [availablDates, setAvailablDates] = useState<BartenderBlock[]>([]);
  console.log("availablDates", availablDates);
  console.log("excludedDates", excludedDates);
  // on rerender update dates
  useEffect(() => {
    setBlockState(bartenderBlocks);
    // one day available api
    const getDateAvailabities = async () => {
      const response = await GET(
        bartenderOneDaySchedule + "/" + id,
        refreshToken
      );
      setAvailablDates([
        ...response.data.map((item: BartenderDateInterFace) => {
          return { ...item, date: moment(item.date).toDate() };
        }),
      ]);
      setExcludedDates([
        //   ...response.data.map((item: BartenderDateInterFace) =>
        //   moment(item.date).toDate()
        // ),
        ...bartenderBlocks.map((item) => moment(item.date).toDate()),
      ]);
    };
    getDateAvailabities();

    // setExcludedDates(bartenderBlocks.map(item => moment(item.date).toDate()))
  }, [bartenderBlocks]);
  const formatDate = (date: Date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  const handleSave = async () => {
    const date = formatDate(selectedDate);
    const body = {
      date: date,
      start_time: startTime + ":00",
      end_time: endTime + ":00",
      is_all_day: false,
    };
    body.is_all_day = true;
    try {
      setLoading(true);
      const response = await POST(
        bartenderBlockedDate + "/" + id,
        body,
        refreshToken
      );
      setBlockState((prev) => [...prev, response?.data?.data]);
      setExcludedDates((prev) => [
        ...prev,
        moment(response?.data?.data.date).toDate(),
      ]);
      setChange(!change);
      resetAll();
      Alert({ message: response?.data?.message });
      setLoading(false);
      setActiveIndex(0);
      setActiveBlock(null);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
    // setModal(true);
    setShowForm(false);
  };

  // const createBlockDate = async () => {
  //   // create a new block date
  //   setModal(false);
  //   try {
  //     setLoading(true);
  //     const response = await POST(
  //       bartenderBlockedDate + "/" + id,
  //       readyData,
  //       refreshToken
  //     );
  //     setBlockState((prev) => [...prev, response?.data?.data]);
  //     setExcludedDates((prev) => [
  //       ...prev,
  //       moment(response?.data?.data.date).toDate(),
  //     ]);
  //     setChange(!change);
  //     resetAll();
  //     Alert({ message: response?.data?.message });
  //     setLoading(false);
  //     setActiveIndex(0);
  //     setActiveBlock(null);
  //   } catch (error) {
  //     console.log(error);
  //     setLoading(false);
  //   }
  // };

  const resetAll = () => {
    // to reset all fields
    setSelectedDate(new Date());
    setStartTime("09:00");
    setEndTime("18:00");
    // setAllDay(false)
    setChanged(false);
    dispatch(formStateChange(false));
  };

  const removeBlockDate = async () => {
    // remove block date from server history
    setModal(false);
    try {
      const list = [...blockState];
      const excludes = [...excludedDates];
      excludes.splice(activeIndex, 1);
      list.splice(activeIndex, 1);
      setBlockState([...list]);
      setExcludedDates([...excludes]);
      const response = await DELETE(
        bartenderBlockedDate + "/" + activeBlock?.id,
        refreshToken
      );
      Alert({ message: response?.data?.message });
      setChange(!change);

      setActiveIndex(0);
      setActiveBlock(null);
    } catch (error) {
      console.log(error);
    }
  };

  interface TimeRange {
    date: string;
    start_time: string;
    end_time: string;
    is_all_day: boolean;
  }
  function formatTimeRange(timeRange: TimeRange): string {
    const { date, start_time, end_time, is_all_day } = timeRange;
    // if all day is true then no need to show the time range
    if (is_all_day) {
      return `${format(toZonedTime(date,
                      Intl.DateTimeFormat().resolvedOptions().timeZone), "MM-dd-yyyy")} (All Day)`;
      // return `${new Date(date).toLocaleDateString()} (All Day)`;
    }

    if (start_time && end_time) {
      // Parse start and end times
      const start = new Date(`${date} ${start_time}`);
      const end = new Date(`${date} ${end_time}`);
      // Calculate duration in hours
      const durationInMs = end.getTime() - start.getTime();
      const durationInHours = durationInMs / (1000 * 60 * 60);
      // Format output string
      const formattedDuration =
        durationInHours === 1 ? "1 hour" : `${durationInHours} hours`;
      return `${dateFunctionUS(date)} ${convertToAMPM(
        start_time
      )} to ${convertToAMPM(end_time)} (${formattedDuration})`;
    }
    return dateFunctionUS(date);
  }

  function convertToAMPM(time24: string): string {
    //time conversions for am pm format
    const hour: number = parseInt(time24.substring(0, 2), 10);
    const minute: string = time24.substring(3);
    const ampm: string = hour >= 12 ? "PM" : "AM";
    const convertedHour: number = hour % 12 || 12;
    return `${convertedHour}:${minute.slice(0, 2)} ${ampm}`;
  }

  // == functionality to block a availeble date
  const selectDateFun = (value: Date) => {
    setSelectedDate(value as Date), setChanged(true);
    dispatch(formStateChange(true));
    availablDates.map((i) => {
      const date = new Date(i.date);
      // if the selected date is in available date
      if (
        `${value?.getDate()}-${value?.getMonth()}-${value?.getFullYear()}` ===
        `${date?.getDate()}-${date?.getMonth()}-${date?.getFullYear()}`
      ) {
        setDateModal(true);
        setActiveBlock(i);
        setShowForm(false)
      }
    });
  };
  const blockAvailbleDate = async () => {
    const response = await DELETE(
      deleteBartenderOneDaySchedule + "/" + activeBlock?.id,
      refreshToken
    );

    setChange(!change); // for rerender
    setDateModal(false);
    setActiveBlock(null);
    setShowForm(true)
  };

  return (
    <div className=" bg-white rounded-2xl p-6 mt-8 w-full">
      <div className="flex justify-between items-center">
        <p className="text-2xl font-semibold">Time Off</p>
        <div
          className="bg-p-gray inline-block p-2 rounded-full cursor-pointer"
          onClick={() => setShowForm(!showForm)}
        >
          <img src={addIcon} width={18} height={18} />
        </div>
      </div>
      <FormModal   width="w-full md:w-[450px]" height="min-h-fit" modalTitle="Add Block Date" isOpen={showForm} onClose={() => setShowForm(false)}>
        <div className=" w-full flex flex-col gap-3 mt-3">
        <p className="text-gray-700 ">
           Enter the date the bartender is not available.
          </p>
          <div>
            <DatePicker
              excludeDates={excludedDates}
              minDate={new Date()}
              dateFormat={"MM-dd-yyyy"}
              className=" w-full cursor-pointer px-4 py-3 bg-p-gray rounded-full    focus:outline-none uppercase focus:ring-1 focus:ring-primary-red  text-gray-600"
              onChange={selectDateFun}
              selected={selectedDate}
            />
          </div>
          <div className="flex flex-wrap gap-3 justify-end items-center">
            <Button
              classes={`px-1 py-1 ${
                changed && !error
                  ? "bg-primary-red-button text-white"
                  : "bg-slate-300  text-gray-500"
              }`}
              disabled={loading || !changed || error}
              onClick={() => handleSave()}
            >
              {loading ? "Loading.." : "Save"}
            </Button>
          </div>
        </div>
      </FormModal>
      {/* {showForm && (
        <div className=" w-full flex flex-col gap-3 mt-3">
          <div>
            <DatePicker
              excludeDates={excludedDates}
              minDate={new Date()}
              dateFormat={"MM/dd/yyyy"}
              className="w-full  px-4 py-2 border rounded-md focus:outline-none"
              onChange={selectDateFun}
              selected={selectedDate}
            />
          </div>
          <div className="flex flex-wrap gap-3 justify-end items-center ">
            <Button
              classes={`
                px-1 py-1
             ${   changed && !error
                  ? "bg-primary-red-button"
                  : "bg-slate-400 hover:bg-slate-400"}`
              }
              disabled={loading || !changed || error}
              onClick={() => handleSave()}
            >
              {loading ? "Loading.." : "Save"}
            </Button>
          </div>
        </div>
      )} */}
        <div className=" text-gray-500 mb-5 mt-[5px] mr-4 text-[14px]">Blocked Dates</div>
  
      <div className="flex flex-wrap gap-2 text-center">
        {blockState &&
          blockState.map((item, index) => {
            return (
              <div
                key={index}
                className="min-w-64 w-full flex items-center gap-2      focus:outline-none uppercase focus:ring-1 focus:ring-primary-red  "
              >
                <p className=" w-full inline-block text-sm  capitalize tracking-wider text-start font-semibold px-6 py-4 bg-p-gray rounded-full">
                  {formatTimeRange(item)}
                  {/* {date.toString()} */}
                </p>
                <div
                  className="cursor-pointer  bg-p-gray rounded-full p-2 w-10 h-10 flex justify-center items-center"
                  onClick={() => {
                    setActiveBlock(item), setActiveIndex(index), setModal(true);
                  }}
                >
                  <img src={deleteIcon}/>
                </div>
              </div>
            );
          })}
      </div>

      {/* delete modal */}
      <ChangesAlert
        title={"Save Changes"}
        desc={`Are you sure you want make this day available?
`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => {
           setModal(false), setActiveBlock(null), setActiveIndex(0);
        }}
        handleSaveChanges={removeBlockDate}
        isOpen={modal}
      />

      <ChangesAlert
        title={"This date is set as available"}
        desc={`Do you want to delete this date from available dates`}
        positiveButtonText={"Yes"}
        negativeButtonText={"Cancel"}
        handleDiscardChanges={() => {
          setShowForm(true)
          setDateModal(false), setSelectedDate(new Date());
        }}
        handleSaveChanges={blockAvailbleDate}
        isOpen={dateModal}
      />
    </div>
  );
};

export default BlockDates;

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
}

